import { MainScreenType } from 'constants/types'
import { useEffect, useState } from 'react'

import ScreenType1 from './screen/screenType1'
import ScreenType2 from './screen/screenType2'
import ScreenType3 from './screen/screenType3'
import ScreenType1Sm from './screen/screenType1Sm'

import { apiMainImageList, apiMainScreen, apiSubSortList } from 'api/api'
import { setDeviceInfo, selectDevice } from 'hooks/deviceInfo'
import { useDispatch, useSelector } from 'react-redux'
import { setUrlInfo } from 'hooks/urlInfo'
import styled from 'styled-components'

import GlobalStyles from 'components/GlobalStyles'

const NavBtnsContainer = styled.div`
	position: fixed;
	top: 20px;
	left: 20px;
	z-index: 9999;
	button {
		margin-right: 20px;
		padding: 5px 10px;
		background: rgba(255, 255, 255, 0.5);
		border: 0;
		outline: 0;
		font-size: 12px;
	}
`

const Main = () => {
	const dispatch = useDispatch()
	const deviceInfo = useSelector(selectDevice)
	const [params, setParams] = useState<MainScreenType>({
		branchCd: '',
		kioskName: '',
	})
	const [pRunList, setPRunList] = useState<any[]>([])
	const [pRunSmList, setPRunSmList] = useState<any[]>([])
	const [cpsList, setCpsList] = useState<any[]>([])
	const [spsList, setSpsList] = useState<any[]>([])
	const [isSmDisplay, setIsSmDisplay] = useState<boolean>(false)
	const [visualList, setVisualList] = useState<any[]>([])

	const [oldCpsList, setOldCpsList] = useState<any[]>([])

	const [isAdmin, setIsAdmin] = useState<boolean>(false)

	const [prunSmImageList, setPrunSmImageList] = useState<any[]>([])
	const [spsImageList, setSpsImageList] = useState<any[]>([])

	useEffect(() => {
		// get url params
		const urlParams = new URLSearchParams(window.location.search)
		const branchCd = urlParams.get('b') || 'brch_0001'
		const kioskName = urlParams.get('k') || 'prun'
		const isSm = urlParams.get('isSm') || '0'
		const admin = urlParams.get('isAdmin') || '0'
		console.log(urlParams)
		console.log(isSm)
		console.log(admin)
		const isSmBoolean: boolean = isSm === '1' ? true : false
		setIsSmDisplay(isSmBoolean)
		setIsAdmin(admin === '1' ? true : false)
		setParams({ branchCd, kioskName })
		const request = {
			branchCd,
			kioskName,
		}
		const urlString = window.location.href
		console.log(urlString)
		console.log(request)
		dispatch(setUrlInfo(urlString))

		apiMainScreen(request)
			.then((res) => {
				console.log(res)
				dispatch(setDeviceInfo(res.result))
				// const videoSample = {
				// 	attachFileId: null,
				// 	er_msg: null,
				// 	fileDest: 'visuals',
				// 	fileExt: 'mp4',
				// 	fileId: 10000,
				// 	fileLocation: '/',
				// 	fileMime: 'video/mp4',
				// 	fileName: 'video.mp4',
				// 	fileNumber: 4,
				// 	fileSize: 100,
				// 	orgFileName:
				// 		'http://app-spot.co.kr:3835/api/video/view/192f796b-b950-44bd-bd39-2b819d27ec44.mp4',
				// 	rs_msg: null,
				// }
				// res.visuals.push(videoSample)

				console.log(res.visuals)
				setVisualList(res.visuals)
				console.table(deviceInfo)
				console.log(res.visuals)
			})
			.then(() => {
				apiSubSortList().then((res) => {
					console.log(res)

					res.forEach((element: any) => {
						if (element.categoryName === 'P.RUN' && element.fileDest === 'icon') {
							setPRunList((prev) => [...prev, element])
						} else if (element.categoryName === 'CPS v2') {
							console.log(element)
							setCpsList((prev) => [...prev, element])
						} else if (element.categoryName === 'SPS') {
							setSpsList((prev) => [...prev, element])
						} else if (element.categoryName === 'CPS' && element.title === '테니스') {
							console.log(element)
							setOldCpsList((prev) => [...prev, element])
						}
					})

					// res.forEach((element: any) => {
					// 	if (element.categoryName === 'CPS') {
					// 		console.log(element)
					// 		if (element.title !== '기타') {
					// 			// 기타는 제외 임시로...
					// 			setCpsList((prev) => [...prev, element])
					// 		}
					// 	}
					// })

					const smOrder = res.filter(
						(item: any, index: number) =>
							item.fileDest === 'iconSm' && item.categoryName === 'P.RUN',
					)
					console.log(smOrder)

					smOrder.sort((itemA: any, itemB: any) => {
						const titles = [
							'안정화',
							'쿠션화',
							'바운싱화',
							'레이싱화',
							'트레일러닝화',
						]
						return titles.indexOf(itemA.title) - titles.indexOf(itemB.title)
					})
					console.log(smOrder)

					setPRunSmList(smOrder)

					// res.forEach((element: any) => {
					// 	if (element.categoryName === 'P.RUN' && element.fileDest === 'icon') {
					// 		setPRunList((prev) => [...prev, element])
					// 	} else if (
					// 		element.categoryName === 'P.RUN' &&
					// 		element.fileDest === 'iconSm'
					// 	) {
					// 		setPRunSmList((prev) => [...prev, element])
					// 	} else if (element.categoryName === 'CPS') {
					// 		setCpsList((prev) => [...prev, element])
					// 	} else if (element.categoryName === 'SPS') {
					// 		setSpsList((prev) => [...prev, element])
					// 	}
					// })
				})
			})

		apiMainImageList().then((res) => {
			console.log(res)
			const prunSmImages = res.filter((item: any) => item.screenCd === 'prun_sm')
			const spsImages = res.filter((item: any) => item.screenCd === 'sps')
			console.log(prunSmImages)
			setPrunSmImageList(prunSmImages)
			console.log(spsImages)
			setSpsImageList(spsImages)
		})

		console.log(deviceInfo?.screenName)
	}, [])

	if (deviceInfo?.screenName === 'P.RUN' && isSmDisplay === false) {
		return (
			<>
				{isAdmin && (
					<NavBtnsContainer>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							P.RUN
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}&isSm=1`)
							}
						>
							P.RUN (작은 아이콘)
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=sps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							SPS
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=cps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							CPS
						</button>
					</NavBtnsContainer>
				)}
				<GlobalStyles />
				<ScreenType1 menuList={pRunList} />
			</>
		)
	} else if (deviceInfo?.screenName === 'P.RUN' && isSmDisplay === true) {
		return (
			<>
				{isAdmin && (
					<NavBtnsContainer>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							P.RUN
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}&isSm=1`)
							}
						>
							P.RUN (작은 아이콘)
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=sps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							SPS
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=cps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							CPS
						</button>
					</NavBtnsContainer>
				)}
				<GlobalStyles />
				<ScreenType1Sm
					menuList={pRunSmList}
					visualList={visualList}
					prunSmImageList={prunSmImageList}
				/>
			</>
		)
	} else if (
		deviceInfo?.screenName === 'CPS' ||
		deviceInfo?.screenName === 'CPS 2026 개편'
	) {
		return (
			<>
				{isAdmin && (
					<NavBtnsContainer>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							P.RUN
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}&isSm=1`)
							}
						>
							P.RUN (작은 아이콘)
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=sps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							SPS
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=cps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							CPS
						</button>
					</NavBtnsContainer>
				)}
				<GlobalStyles />
				<ScreenType2
					menuList={cpsList}
					oldMenuList={oldCpsList}
				/>
			</>
		)
	} else if (deviceInfo?.screenName === 'SPS') {
		return (
			<>
				{isAdmin && (
					<NavBtnsContainer>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							P.RUN
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=prun&isAdmin=${isAdmin ? '1' : '0'}&isSm=1`)
							}
						>
							P.RUN (작은 아이콘)
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=sps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							SPS
						</button>
						<button
							type="button"
							onClick={() =>
								(window.location.href = `/?b=${
									params.branchCd
								}&k=cps&isAdmin=${isAdmin ? '1' : '0'}`)
							}
						>
							CPS
						</button>
					</NavBtnsContainer>
				)}
				<GlobalStyles />
				<ScreenType3
					menuList={spsList}
					visualList={visualList}
					spsImageList={spsImageList}
				/>
			</>
		)
	} else {
		return <></>
	}
}

export default Main
